/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-03-02 16:25:49
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import CellCommon from './CellCommon';
import { ICheckbox } from './types';
import Radio from '../Radio';
import Checkbox from '../Checkbox';

const CellCheckbox = ({ value = '', checked, onClick, ...rest }: ICheckbox) => {
  const handleOnClick = useCallback(() => {
    if (onClick) onClick(value);
  }, [onClick, value]);

  return (
    <>
      <CellCommon {...rest} arrow={false} onClick={handleOnClick}>
        <Checkbox checked={checked} />
      </CellCommon>
    </>
  );
};

export default CellCheckbox;
